export const FORMATTER_ARGS = /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g;
export const FORMATTER_SPLIT = /\s+/;
